import { Mapper } from "planning-portal-library/src/lib/core/base";
import { VehicleGroupWebEntity } from "./vehicle-group-web-entity";
import { VehicleGroup } from "planning-portal-library/src/lib/core/domain";

export class vehicleGroupWebRepositoryMapper extends Mapper<VehicleGroupWebEntity, VehicleGroup> {
    mapFrom(param: VehicleGroupWebEntity): VehicleGroup {
      return {
        id: param.id,
        planId: param.planId,
        groupTitle:param.groupTitle ?? undefined,
        vehicleTypeName: param.vehicleTypeName,
        quantity: param.quantity,
        capacityType1: param.capacityType1 ?? undefined,
        capacityType2: param.capacityType2 ?? undefined,
        capacityType3: param.capacityType3 ?? undefined,
        tenantId : param.tenantId,
        vehicleTypeId: param.vehicleTypeId,
        vehicleType: param.vehicleType,
      };
    }
  
    mapTo(param: VehicleGroup): VehicleGroupWebEntity {
      return {
        id : param.id,
        planId: param.planId,
        groupTitle:param.groupTitle,
        vehicleTypeName:param.vehicleTypeName,      
        quantity: param.quantity,
        capacityType1: param.capacityType1,
        capacityType2: param.capacityType2,
        capacityType3: param.capacityType3,
        tenantId:param.tenantId,
        vehicleTypeId: param.vehicleTypeId,
        vehicleType: param.vehicleType,
      };
    }
  }